<i18n>
{
  "fr": {
    "tool-title": "Percentiles (2010-2019)",
    "depth-label": "Profondeur [m]",
    "legend-label": "Probabilité de dépassement du seuil sélectionné"
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="tool" id="gw-percentiles-raster-depth" v-if="show">
    <h3>{{$t('tool-title')}}</h3>

    <div class="option-content">
      <md-field class="depth-filter">
        <label>{{ $t('depth-label') }}</label>
        <md-input
          v-model="selectedValueFilter"
          type="number"
          step="0.1"
        />
      </md-field>
    </div>

    <h4>{{ $t('legend-label') }}</h4>
    <img class="legend" :src="legendUrl" />
  </div>
</template>

<script>

import LayerStoreMixin from '@/mixins/store/layer'

export default {
  name: 'GwPercentilesRasterDepth',
  mixins: [
    LayerStoreMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return  {
      debounceValueFilter: null,
      selectedValueFilter: null
    }
  },
  mounted() {
    this.selectedValueFilter = typeof this.currentDepth === 'undefined' ? this.params.defaultValue : this.currentDepth
  },
  computed: {
    show () {
      return true
    },
    layer () {
      return this.selectedLayers[0]
    },
    legendUrl () {
      return `${this.layer.getSource().getLegendUrl()}&sld_version=1.1.0`
    },
    currentDepth () {
      return this.layer.getSource().getParams().depth
    }
  },
  watch: {
    selectedValueFilter() {
      if (this.debounceValueFilter !== null)
        clearTimeout(this.debounceValueFilter);
      this.debounceValueFilter = setTimeout(() => this.updateValueFilter(), 50);
    }
  },
  methods: {
    updateValueFilter() {
      let currentParams = this.layer.getSource().getParams();
      currentParams.depth = this.selectedValueFilter;
      this.layer.getSource().updateParams(currentParams);
    },
    handleError (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  .wide #legend {
    width: calc(33% - 5px);
    margin-right: 5px;
  }
</style>
